/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cognito_Invitation_Password_LabelInputs */

const en_cognito_invitation_password_label = /** @type {(inputs: Cognito_Invitation_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporary password:`)
};

const pt_br2_cognito_invitation_password_label = /** @type {(inputs: Cognito_Invitation_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senha temporária:`)
};

/**
* | output |
* | --- |
* | "Temporary password:" |
*
* @param {Cognito_Invitation_Password_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cognito_invitation_password_label = /** @type {((inputs?: Cognito_Invitation_Password_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cognito_Invitation_Password_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cognito_invitation_password_label(inputs)
	return pt_br2_cognito_invitation_password_label(inputs)
});